import React from 'react';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Preliminares = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-01" className={classes.title}>
                1. DAS DISPOSIÇÕES PRELIMINARES
            </Title>

            <Title variant="h6" className={classes.subtitle} >
                <span className={classes.item}>1.1</span> Da Natureza
            </Title>

            <Typography className={classes.text} variant="body2">
                A {edicao}ª Olimpíada de Professores da OBMEP Mirim é uma ação exclusivamente cultural e recreativa, sendo a participação absolutamente voluntária e desvinculada à aquisição de qualquer bem, serviço e/ou direito.
            </Typography>

            <Title variant="h6" className={classes.subtitle} >
                <span className={classes.item}>1.2</span> Da Realização
            </Title>
            <Typography className={classes.text} variant="body2">
                A Olimpíada de Professores da OBMEP Mirim é uma realização do <span className={classes.bolder}>IMPA</span> com apoio da B3 Social, promovida com recursos oriundos do contrato de gestão firmado pelo <span className={classes.bolder}>IMPA</span> com o Ministério da Ciência, 
                Tecnologia e Inovação (MCTI) e com o Ministério da Educação (MEC).
            </Typography>
            
            <Title variant="h6" className={classes.subtitle} >
                <span className={classes.item}>1.3</span> Da Abrangência
            </Title>
            <Typography className={classes.text} variant="body2">
                A {edicao}ª Olimpíada de Professores da OBMEP Mirim é dirigida aos professores do Ensino Fundamental I (1º, 2º, 3º, 4º ou 5º anos), com matrícula ativa em escolas públicas municipais, estaduais e federais e escolas privadas localizadas no território brasileiro.
            </Typography>

            <Title variant="h6" className={classes.subtitle} >
                <span className={classes.item}>1.4</span> Dos Objetivos
            </Title>
            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.bolder}>São objetivos da {edicao}ª Olimpíada de Professores da OBMEP Mirim:</span>

                <ul className={classes.list}>
                    <li><span className={classes.item}>1.4.1</span> Aprimorar as habilidades dos professores do Ensino Fundamental I na resolução de questões de natureza olímpica;</li>
                    <li><span className={classes.item}>1.4.2</span> Estimular a participação dos alunos na OBMEP Mirim por meio da atuação direta de seus professores;</li>
                    <li><span className={classes.item}>1.4.3</span> Ampliar o engajamento das escolas na OBMEP Mirim, fortalecendo a cultura matemática em suas comunidades;</li>
                    <li><span className={classes.item}>1.4.4</span> Contribuir para a melhoria da qualidade da educação básica, oferecendo aos professores oportunidades de formação e reconhecimento;</li>
                    <li><span className={classes.item}>1.4.5</span> Valorizar o papel do docente na construção de uma percepção positiva da matemática, desenvolvendo raciocínio lógico e criatividade;</li>
                    <li><span className={classes.item}>1.4.6</span> Difundir a cultura matemática em todo o território nacional, a partir de ações que integrem professores, alunos e escolas.</li>
                </ul>
            </Typography>
        </>
    )
}

export default Preliminares;